import React, { FC } from 'react';

import { Avatar, AvatarProps } from 'Modules/ui3';

import { ICON_PATH_BY_BIK } from '../../icons';


interface ParticipantAvatarProps extends AvatarProps {
    bik?: string;
    name?: string;
}

const getBankIconByBik = (bik?: string) => {
    if (!bik)
        return null;

    const src = ICON_PATH_BY_BIK[bik];
    return src ? <img src={src} alt='' style={{ width: '100%', height: '100%' }} /> : null;
};


export const ParticipantAvatar: FC<ParticipantAvatarProps> = ({ bik, name, size = 'S', ...props }) => {
    const avatarContent = getBankIconByBik(bik) ?? name;
    return (
        <Avatar size={size} {...props}>
            {avatarContent}
        </Avatar>
    );
};
